import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { useMatchReminders } from "../hooks/useMatchReminders";

function formatKickoff(dateStr, timeStr) {
  try {
    const d = new Date(dateStr);
    const dateLabel = d.toLocaleDateString("en-GB", {
      weekday: "short",
      day: "numeric",
      month: "short",
    });
    const timeLabel =
      timeStr ||
      d.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "Europe/London",
      });
    return `${dateLabel} · ${timeLabel}`;
  } catch {
    return timeStr || "";
  }
}

export function MatchReminderBell() {
  const { reminders, count } = useMatchReminders();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="relative text-white hover:text-[#2BAEE5] transition-colors p-1"
        data-testid="match-reminder-bell"
        aria-label={count > 0 ? `${count} pending match predictions` : "Match reminders"}
      >
        <Bell className="w-5 h-5" />
        {count > 0 && (
          <span
            className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center border border-[#7C2C3B]"
            data-testid="match-reminder-badge"
          >
            {count}
          </span>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72" data-testid="match-reminder-menu">
        <DropdownMenuLabel className="text-[#7C2C3B] font-bold">
          Match Reminders
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {count === 0 ? (
          <div className="px-3 py-4 text-xs text-slate-500 text-center" data-testid="match-reminder-empty">
            You&apos;re all caught up. Nothing kicking off in the next 2 hours.
          </div>
        ) : (
          <>
            {reminders.map((fx) => (
              <DropdownMenuItem asChild key={fx.id}>
                <Link
                  to="/score-predictor"
                  className="flex flex-col items-start gap-0.5 py-2"
                  data-testid={`match-reminder-item-${fx.id}`}
                >
                  <span className="text-sm font-semibold text-slate-900">
                    West Ham v {fx.opponent}
                  </span>
                  <span className="text-[11px] text-slate-500">
                    {formatKickoff(fx.date, fx.time)} · {fx.competition}
                  </span>
                  <span className="text-[11px] font-semibold text-[#7C2C3B]">
                    Predict now →
                  </span>
                </Link>
              </DropdownMenuItem>
            ))}
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default MatchReminderBell;
